/* unplugin-vue-components disabled */import script from "./PublishCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublishCreate.vue?vue&type=script&lang=ts&setup=true"

import "./PublishCreate.vue?vue&type=style&index=0&id=21be7d07&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21be7d07"]])

export default __exports__